/**
 * Configuração do Firebase para o navegador.
 *
 * **Estas chaves NÃO são segredo.** Parece contraintuitivo, mas a `apiKey` do
 * Firebase é um identificador público, feito para viajar no código da página —
 * qualquer pessoa que abra o sistema consegue lê-la, por construção. O que
 * protege não é escondê-la, e sim:
 *
 *   1. os domínios autorizados (só `localhost` e os do projeto podem hospedar
 *      a tela de login);
 *   2. o backend, que verifica cada token e cruza com a tabela `pessoas` —
 *      estar autenticado no Google não dá acesso a nada por si só.
 *
 * Por isso este arquivo fica no repositório, ao contrário das chaves da
 * Anthropic e do Serper, que são segredo de verdade e vivem no Secret Manager.
 */

import { initializeApp } from 'firebase/app';
import { GoogleAuthProvider, getAuth } from 'firebase/auth';

export const app = initializeApp({
  apiKey: 'AIzaSyBl3s7mrYA2aB52BiI2Zd1bypLZoxsNR0g',
  authDomain: 'sistema-cd-ademaldo.firebaseapp.com',
  projectId: 'sistema-cd-ademaldo',
  storageBucket: 'sistema-cd-ademaldo.firebasestorage.app',
  messagingSenderId: '879778027721',
  appId: '1:879778027721:web:696d2bd56e66c44c6cd518',
});

export const auth = getAuth(app);

export const provedorGoogle = new GoogleAuthProvider();
// Faz o Google perguntar qual conta usar, em vez de entrar direto na última.
// O Lucas tem conta pessoal e profissional na mesma máquina, e entrar na errada
// é um erro silencioso: a tela abre, mas o acesso é negado por outro motivo.
provedorGoogle.setCustomParameters({ prompt: 'select_account' });
